import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { Bell, X } from "lucide-react";

function Notificacoes() {
  const [notificacoes, setNotificacoes] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (!token) return;

    axios
      .get("/api/api/notificacoes", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setNotificacoes(res.data.Result || []))
      .catch(() => setNotificacoes([]));
  }, []);

  const naoLidas = notificacoes.filter((n) => n.lido === 0).length;

  const marcarComoLida = (id) => {
    const token = localStorage.getItem("Token");
    axios
      .delete(`/api/api/notificacoes/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => setNotificacoes((prev) => prev.filter((n) => n.id !== id)))
      .catch(() => {});
  };

  const modalContent = (
    <>
      {open && <div className="popup-overlay" onClick={() => setOpen(false)} />}
      {open && (
        <div className="popup">
          <div className="popup-header">
            <span>Notificações</span>
            <button onClick={() => setOpen(false)}>
              <X size={16} />
            </button>
          </div>

          <div className="popup-list">
            {notificacoes.length === 0 ? (
              <div className="empty">Nenhuma notificação</div>
            ) : (
              notificacoes.map((n) => (
                <div
                  key={n.id}
                  className={`cardt ${n.lido === 0 ? "unread" : ""}`}
                  onClick={() => marcarComoLida(n.id)}
                >
                  <div className="msg">{n.mensagem}</div>
                  <div className="date">
                    {new Date(n.criado_em).toLocaleDateString()}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </>
  );

  return (
    <div className="notificacoes-container">
      <div className="bell-icon" onClick={() => setOpen(true)}>
        <Bell size={22} />
        <span className={`badge ${naoLidas === 0 ? "zero" : ""}`}>
          {naoLidas}
        </span>
      </div>

      {ReactDOM.createPortal(
        modalContent,
        document.getElementById("modal-root")
      )}
    </div>
  );
}

export default Notificacoes;
